import {
  type BillingDetails,
  type BillingDetailsAddress,
} from '@service-initiation/tech-care-data-access-store';

import { billingDetailsFormSchema } from './schemas';

export const completedBillingDetails = (
  billingDetails:
    | Partial<
        Omit<BillingDetails, 'billingAddress'> & {
          billingAddress: Partial<BillingDetailsAddress>;
        }
      >
    | undefined
): boolean => {
  if (
    billingDetails &&
    (!billingDetails.firstName ||
      !billingDetails.lastName ||
      !billingDetails.billingAddress)
  ) {
    return false;
  }

  return (
    !!billingDetails?.payment_intent_id &&
    billingDetailsFormSchema().isValidSync({
      ...billingDetails?.billingAddress,
      billingIsSame: billingDetails?.billingIsSame,
      firstName: billingDetails?.firstName,
      lastName: billingDetails?.lastName,
    })
  );
};
